<style lang="scss">
@import 'node_modules/inomph-common/src/assets/sass/main.scss';

.main-content-nopad {
  padding-left: 300px;
  padding-right: 0px;
}
.v-text-field input {
  border-bottom: none !important;
  // margin-bottom: 0 !important;
}
.v-input #productName {
  font-size: 30px;
  padding: 13px 0px;
}
.v-input__control>.v-input__slot>.v-text-field__slot>input[type=text], .v-input__control>.v-input__slot>.v-text-field__slot>input[type=number] {
    margin: 0!important;
}

@media only screen and (max-width: 992px) {
  .main-content-nopad {
    padding-left: 0px;
    padding-right: 0px;
  }
}

.main-content-padded {
  padding-top: 24px;
  padding-left: 332px;
  padding-right: 32px;
}

.modal-close {
  cursor: pointer;
}

@media only screen and (max-width: 992px) {
  .main-content-padded {
    padding-top: 24px;
    padding-left: 32px;
    padding-right: 32px;
  }
}

@media only screen and (max-width: 992px) {
  .main-content-nopad-small {
    padding-left: 0px;
    padding-right: 0px;
  }
}

.accent--text {
  color: #005caf !important;
  caret-color: #005caf !important;
}
</style>

<template lang="pug">
#app
  v-app#inspire
    router-view
</template>
<script>
export default {
  name: 'App',
  computed: {
    user () {
      return this.$store.state.auth.user
    }
  },
  watch: {
    user (user) {
      if (!user) {
        this.$router.replace({ name: 'login' })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue